import { motion } from "framer-motion";
import ButtonComponent from "../../components/elements/ButtonComponent";
import { useEffect, useState } from "react";
import "./css/css.css";
import AddNewUser from "./popups/AddNewUser";
import {
  ADMIN_STAFF_UID,
  CREDITOR_USERS,
  useAxiosInstance,
} from "../../api/axios";
import { useMutation } from "@tanstack/react-query";
import { ADMIN_STAFF } from "../../api/apiClient";
import Lottie from "react-lottie";
import animationData from "../../jsons/Loading333.json";
import OrderDetailsHeader from "../../components/common/OrderDetailsHeader";

const Vam30Users = () => {
  const api = useAxiosInstance();
  const [popup, setPopup] = useState<boolean>(false);
  const [staffData, setStaffData] = useState<any>(undefined);
  const [userCounts, setUserCounts] = useState<any>(undefined);
  const [creditorUid, setCreditorUid] = useState<any>(undefined);
  const onClose = () => {
    setPopup(false);
  };

  const defaultOptions = {
    loop: true,
    autoplay: true,
    animationData: animationData,
    renderer: "svg",
  };

  const getCreditorUsers = (creditor_uid: string) =>
    api.get(CREDITOR_USERS(creditor_uid)).then((res) => res.data.data.results);

  const creditorUserMutate = useMutation({
    mutationFn: (data: any) => getCreditorUsers(data),
  });

  const getStaffs = () =>
    api.get(ADMIN_STAFF).then((res) => res.data.data.result);

  const staffMutate = useMutation({
    mutationFn: getStaffs,
    onSuccess(data) {
      setStaffData([...data]);
      setUserCounts(data?.length);
      if (data?.length > 0) {
        setCreditorUid(data[0]?.creditor_uid);
        creditorUserMutate.mutate(data[0]?.creditor_uid);
      }
    },
  });

  useEffect(() => {
    staffMutate.mutate();
  }, []);

  const UserCard = ({ data, index }: any) => {
    const [active, setActive] = useState<any>(data?.is_active);
    const spring = {
      type: "spring",
      stiffness: 200,
      damping: 30,
    };

    const spring_between = {
      type: "spring",
      stiffness: 200,
      damping: 30,
      bounce: 0.25,
      duration: 1,
      x: { duration: 1.5, repeat: Infinity },
    };

    async function activeHandeler(state: any) {
      if (state === true) {
        setActive(2);

        try {
          await api
            .put(ADMIN_STAFF_UID(data?.staff_uid), { is_active: false })
            .then((res) => {
              setActive(false);
            });
        } catch (e) {
          setActive(true);
        }
      } else {
        setActive(2);

        try {
          await api
            .put(ADMIN_STAFF_UID(data?.staff_uid), { is_active: true })
            .then((res) => {
              setActive(true);
            });
        } catch (e) {
          setActive(false);
        }
      }
    }

    return (
      <>
        <div className="flex justify-between pr-4 py-2 pl-6 h-10 w-full items-center border rounded-lg border-gray-200">
          <div className="flex gap-3 w-[200px]">
            <p className="text-right text-gray-900 text-Body-OneLine/12/Regular">
              {index + 1}
            </p>
            <p className="text-gray-900 text-Body-OneLine/14/Medium">
              {data?.user}
            </p>
          </div>
          <div className="flex gap-3 w-[100px] text-center items-center justify-center">
            <p className="text-gray-900 text-Body-OneLine/14/Medium text-center">
              {data?.phone_number}
            </p>
          </div>
          <div className="flex gap-3 w-[130px] items-center justify-end">
            <p
              className={`${
                active ? `text-primary-400` : `text-gray-600`
              } text-Body-OneLine/14/bold`}
            >
              {active === true ? `فعال` : active !== 2 ? `غیر فعال` : ``}
            </p>

            <div
              onClick={() => activeHandeler(active)}
              className="flex flex-row gap-1 justify-center items-center"
            >
              <div
                className={`switch cursor-pointer ${
                  active === false
                    ? `bg-gray-200`
                    : active === 2
                    ? `bg-yellow-300`
                    : `bg-primary-600`
                }`}
                data-isOn={active}
              >
                <motion.div
                  className="handle bg-white"
                  animate={{
                    scale: active === 2 ? [1, 0.5] : [0.5, 1],
                    x: active === 2 ? [0, 5, 0, -5, 0, 5, 0, -5, 0] : 0,
                  }}
                  transition={active === 2 ? spring_between : spring}
                />
              </div>
            </div>
          </div>
        </div>
      </>
    );
  };

  return (
    <div className="pt-4 pr-8 bg-gray-100">
      {" "}
      <OrderDetailsHeader
        maxWidth="px-4 max-w-[1900px]"
        showDate
        headerLabel="کاربران وامسی"
        showBackBtn={false}
      />
      <div className=" flex flex-col items-start justify-start gap-10 w-full h-screen bg-gray-100">
        <div className="flex w-full justify-start items-center gap-3 max-h-[800px]">
          <div className="flex flex-col gap-2 rounded-2xl max-h-[800px] justify-start items-start px-6 bg-white w-full h-screen">
            <div className="flex flex-col gap-6 mt-12">
              <ButtonComponent
                onClick={() => setPopup(true)}
                variant="elevated"
                hasIcon
                icon={<img src="/icons/plus-outline.svg" alt="not found" />}
              >
                افزودن کاربر جدید
              </ButtonComponent>
              {staffMutate.isPending ? null : (
                <p className="text-primary-600 text-Body-OneLine/12/Light">
                  تعداد نفرات: {userCounts}
                </p>
              )}
            </div>
            <div
              style={{ scrollbarWidth: "none" }}
              className="flex w-full flex-col gap-2 justify-start items-start max-h-[640px] overflow-y-scroll py-5"
            >
              {staffMutate.isPending ? (
                <div className=" h-[500px] flex items-center justify-center mx-auto z-10 ">
                  <Lottie options={defaultOptions} height={100} width={100} />
                </div>
              ) : (
                <>
                  {staffData?.map((item: any, index: number) => (
                    <>
                      <UserCard data={item} index={index} />
                    </>
                  ))}
                </>
              )}
            </div>
          </div>
          <div></div>
        </div>
        {popup ? (
          <AddNewUser
            Mutation={staffMutate}
            creditorUid={creditorUid}
            onClose={onClose}
          />
        ) : null}
      </div>
    </div>
  );
};

export default Vam30Users;
